import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass({ required: _ctx.input.required })
      }, _toDisplayString(_ctx.input.label), 3)
    ]),
    _createVNode(_component_Datepicker, {
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
      clearable: true,
      autoApply: true,
      enableTimePicker: false,
      locale: "en-US",
      dark: ""
    }, null, 8, ["modelValue"])
  ]))
}